<template>
  <v-card
    class="item-cards"
    :style="`background-image: linear-gradient(to top, rgba(255, 255, 255, 1), 70%, rgba(255, 255, 255, 0)), url('${src}')`"
  >
    <v-avatar
      class="ma-3"
      size="125"
      tile
    >
      <v-img 
        :src="src"
        width="128px"
        height="128px"
      ></v-img>
    </v-avatar>
    <v-card-title><a :href="uri">{{name}}</a></v-card-title>
    <v-card-subtitle>
      <span 
        v-for="(artist, i) in artists"
        :key="artist.id"
      >
        <a
          :href="artist.uri"  
        >{{artist.name}}</a>
        <span v-if="i != artists.length - 1">, </span>
      </span>
      • {{release_date}} • {{type.charAt(0).toUpperCase() + type.slice(1)}}
    </v-card-subtitle>
  </v-card>
</template>

<script>
export default {
    props: ['src', 'name', 'uri', 'release_date', 'artists', 'type']
}
</script>

<style>
  a {
    text-decoration: none;
  }

  .item-cards {
    background: white;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: linear-gradient(to top, rgba(255, 255, 255, 1), 70%, rgba(255, 255, 255, 0)), url('https://i.scdn.co/image/ab67616d0000b273a897b454861e19b067bd0214');
  }
</style>